import { render, staticRenderFns } from "./MeetingDetails.vue?vue&type=template&id=25fe55c0"
import script from "./MeetingDetails.vue?vue&type=script&lang=ts"
export * from "./MeetingDetails.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports